import {
    OPEN_CONFIRMATION_DIALOG,
    CLOSE_CONFIRMATION_DIALOG
} from '../../actions'

const initialState = {
    open: false,
    title: null,
    message: null,
    positiveAction: null,
    negativeAction: null
}

const confirmationDialog = (state = initialState, action) => {
    switch (action.type) {
        case OPEN_CONFIRMATION_DIALOG:
            return {
                ...state,
                ...initialState,
                open: true,
                ...action.payload
            }
        case CLOSE_CONFIRMATION_DIALOG:
            return {
                ...state,
                open: false
            }
        default:
            return state
    }
}

export default confirmationDialog



// WEBPACK FOOTER //
// ./src/reducers/ui/confirmationDialog.js